import { CompatibilityGuideBootstrap } from './models/compatibility-guide-bootstrap';
import { clearSelectOptions } from './utils/clear-select-options';

declare var productApiConfig: any;

export const bootstrap: CompatibilityGuideBootstrap = (manufacturersFields: NodeListOf<HTMLElement>) => {
  Array.prototype.forEach.call(manufacturersFields, (manufacturersField: HTMLElement) => {
    const manufacturerSelect: HTMLSelectElement = manufacturersField.querySelector('select');
    const formElement = manufacturersField.parentNode.parentNode;

    const manufacturerTypes = manufacturerSelect.dataset.cgTypes;
    const manufacturersUrl = productApiConfig.compatibilityGuideUrl + 'api/manufacturer?types=' + manufacturerTypes;
    const manufacturersXhr = new XMLHttpRequest();
    manufacturersXhr.open('GET', manufacturersUrl, true);
    manufacturersXhr.send();
    manufacturersXhr.onreadystatechange = () => {
      if (manufacturersXhr.readyState !== 4 || manufacturersXhr.status !== 200) {
        return;
      }

      const manufacturers = JSON.parse(manufacturersXhr.responseText);
      manufacturers.forEach((manufacturer: { id: string; name: string; }) => {
        const option: HTMLOptionElement = document.createElement('option');
        option.dataset.manufacturerId = manufacturer.id;
        option.appendChild(document.createTextNode(manufacturer.name));
        option.value = manufacturer.name;
        manufacturerSelect.appendChild(option);
      });
    };

    const modelsElement: HTMLElement | null = formElement.querySelector('.cg-models');
    if (modelsElement === null) {
      return;
    }

    const modelsSelect: HTMLSelectElement = modelsElement.querySelector('select');
    manufacturerSelect.addEventListener('change', () => {
      const selectedManufacturerOption = manufacturerSelect.options[manufacturerSelect.selectedIndex];
      clearSelectOptions(modelsSelect, 1);

      if (selectedManufacturerOption.value !== '') {
        manufacturerSelect.disabled = true;
        modelsSelect.disabled = true;
        const modelsXhr = new XMLHttpRequest();
        modelsXhr.open('GET', productApiConfig.compatibilityGuideUrl + 'api/manufacturer/' + selectedManufacturerOption.dataset.manufacturerId + '?types=' + manufacturerTypes);
        modelsXhr.send();
        modelsXhr.onreadystatechange = () => {
          if (modelsXhr.readyState !== 4 || modelsXhr.status !== 200) {
            return;
          }

          const models = JSON.parse(modelsXhr.responseText);
          Array.prototype.forEach.call(models, (model: { name: string; }) => {
            const option: HTMLOptionElement = document.createElement('option');
            option.appendChild(document.createTextNode(model.name));
            option.value = model.name;
            modelsSelect.appendChild(option);
          });

          manufacturerSelect.disabled = false;
          modelsSelect.disabled = false;
          modelsElement.style.display = 'block';
        };
      } else {
        modelsSelect.disabled = false;
        modelsElement.style.display = 'none';
      }
    });
  });
};
